import { AAGUID } from '@interticket/core';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { IListResult } from '@core/interfaces/list-result/list-result.interface';
import { SearchParams } from '@core/models/query-params/search-params.model';
import { EVENT_LIST, EVENT_VIEW, EVENT_OTHER_DATES } from '@core/mocks/event/event.mock';
import { IEventsSource } from '../../interfaces/event/events-source.interface';
import { IEventView } from '../../interfaces/event/event-view.interface';
import { EventFilter } from '../../models/event/event-filter.model';
import { IEventListItem } from '../../interfaces/event/event-list-item.interface';
import { IEventViewBase } from '@core/interfaces/event/event-view-base.interface';

@Injectable()
export class EventsSourceMockService implements IEventsSource {

  getEvent(eventId: AAGUID): Observable<IEventView> {
    return of(EVENT_VIEW).pipe(delay(350));
  }

  getList(searchParams?: SearchParams, filter?: EventFilter): Observable<IListResult<IEventListItem>> {
    return of(EVENT_LIST).pipe(delay(750));
  }

  getMoreEvents(id: AAGUID): Observable<IListResult<IEventViewBase>> {
    return of(EVENT_OTHER_DATES).pipe(delay(550));
  }

  getListByIds(eventIds: AAGUID[]): Observable<IEventView[]> {
    return of([
      EVENT_VIEW,
      { ...EVENT_VIEW, id: 'eventId2', name: 'Event 2' },
    ])
      .pipe(delay(300));
  }

  getCalendarEvents(): Observable<IListResult<IEventViewBase>> {
    return of(EVENT_OTHER_DATES).pipe(delay(1500));
  }

}
